module.exports = __webpack_public_path__ + "static/media/LB_05.c0fb3ef4.jpg";